import { Component, OnInit } from '@angular/core';
import {UserRole} from "../../../../components/rename/add-user-role/add-user-role.component";

@Component({
  selector: 'app-all-session-tables',
  templateUrl: './all-session-tables.component.html',
  styleUrls: ['./all-session-tables.component.scss']
})
export class AllSessionTablesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
